// extracted by mini-css-extract-plugin
export var btn = "H_mD x_sx x_sg d_bw d_bL d_bz d_ds";
export var full = "H_tx d_s d_D";